import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';

export function getUsNationalDigits(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}

export function formatUsPhoneInput(value) {
  const digits = getUsNationalDigits(value).slice(0, 10);
  return digits ? new AsYouType('US').input(digits) : '';
}

export function normalizeUsPhone(value) {
  const digits = getUsNationalDigits(value);
  if (!digits) return '';
  return digits.length === 10 ? `+1${digits}` : digits.slice(0, 10);
}

export function getUsPhoneState(value) {
  const digits = getUsNationalDigits(value);
  if (!digits) return { status: 'empty', digits, remaining: 10 };
  if (digits.length < 10) {
    return { status: 'incomplete', digits, remaining: 10 - digits.length };
  }
  if (digits.length > 10) return { status: 'invalid', digits, remaining: 0 };

  const parsed = parsePhoneNumberFromString(digits, 'US');
  return {
    status: parsed?.country === 'US' && parsed.isValid() ? 'valid' : 'invalid',
    digits,
    remaining: 0,
    e164: parsed?.number || '',
  };
}

export function isValidUsPhoneNumber(value) {
  return getUsPhoneState(value).status === 'valid';
}
